import { c as _c } from "react/compiler-runtime";
import { ReactElement, memo } from 'react';
import ServiceTeaserComponent, { ServiceTeaser } from '../service-teaser/service-teaser.component';
import ConfigurableCmsSlotMetadata from '../../top-level-components/cms-page/metadata/configurable/configurable-cms-slot-metadata.component';
import ConfigurableCmsValidity from '@spa/top-level-components/cms-page/metadata/configurable/configurable-cms-validity.component';
import HeadlineComponent from '../headline/headline.component';
import { LinkComponentLink } from '../link/link.component';
import { Metadata } from '@spa/pages-converters/cms/component-envelops/CmsComponentEnvelopBase';
import styles from './service-teaser-list.component.module.scss';
interface ServiceTeaserList {
  readonly headline: string | null;
  readonly subHeadline: string | null;
  readonly headlineLink: LinkComponentLink | null;
  readonly serviceTeasers: ReadonlyArray<ServiceTeaser>;
  readonly serviceTeasersMetadata: ReadonlyArray<Metadata>;
}
export interface Props {
  readonly id: string;
  readonly editorMode: boolean;
  readonly dateTo: number | null;
  readonly dateFrom: number | null;
  readonly serviceTeaserList: ServiceTeaserList;
}
function ServiceTeaserListComponent(t0) {
  const $ = _c(27);
  const {
    id,
    editorMode,
    dateFrom,
    dateTo,
    serviceTeaserList: t1
  } = t0;
  const {
    headline,
    headlineLink,
    serviceTeasers,
    serviceTeasersMetadata,
    subHeadline
  } = t1;
  let t2;
  if ($[0] !== dateFrom || $[1] !== dateTo || $[2] !== editorMode || $[3] !== serviceTeasersMetadata) {
    t2 = editorMode && <><ConfigurableCmsSlotMetadata beforeSlot={true} metadata={serviceTeasersMetadata} /><ConfigurableCmsValidity dateFrom={dateFrom} dateTo={dateTo} /></>;
    $[0] = dateFrom;
    $[1] = dateTo;
    $[2] = editorMode;
    $[3] = serviceTeasersMetadata;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== headline || $[6] !== headlineLink || $[7] !== id || $[8] !== subHeadline) {
    t3 = headline && <HeadlineComponent id={`${id}-headline`} usedInFullWidthComponent={true} headline={headline} link={headlineLink} subHeadline={subHeadline} />;
    $[5] = headline;
    $[6] = headlineLink;
    $[7] = id;
    $[8] = subHeadline;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== editorMode || $[11] !== serviceTeasers) {
    let t5;
    if ($[13] !== editorMode) {
      t5 = teaser => <li key={teaser.id}><ServiceTeaserComponent editorMode={editorMode} serviceTeaser={teaser} /></li>;
      $[13] = editorMode;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    t4 = serviceTeasers.map(t5);
    $[10] = editorMode;
    $[11] = serviceTeasers;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[15] !== t4) {
    t5 = <ul className={styles["service-teaser-list__list"]}>{t4}</ul>;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t3 || $[18] !== t5) {
    t6 = <div className={styles["service-teaser-list"]}>{t3}{t5}</div>;
    $[17] = t3;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== editorMode || $[21] !== serviceTeasersMetadata) {
    t7 = editorMode && <ConfigurableCmsSlotMetadata beforeSlot={false} metadata={serviceTeasersMetadata} />;
    $[20] = editorMode;
    $[21] = serviceTeasersMetadata;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t2 || $[24] !== t6 || $[25] !== t7) {
    t8 = <>{t2}{t6}{t7}</>;
    $[23] = t2;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
}
export default memo(ServiceTeaserListComponent);